﻿export const getSatser = async (): Promise<UtstyrsstipendSatser> => {
    const response = await fetch('/api/mt1535/satser/utstyrsstipend');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface UtstyrsstipendSatser {
    SATS_ST01_UTSTYRSSTIPEND_GRUPPE1_FOM2023: number;
    SATS_ST01_UTSTYRSSTIPEND_GRUPPE2_FOM2023: number;
    SATS_ST01_UTSTYRSSTIPEND_GRUPPE3_FOM2023: number;
    SATS_ST01_UTSTYRSSTIPEND_GRUPPE4_FOM2023: number;
    SATS_ST01_UTSTYRSSTIPEND_GRUPPE5_FOM2023: number;
}
